var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmployeeIconActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_50_5540)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.85299 16.8819C8.85299 16.8819 7.70593 16.8819 7.70593 15.7348C7.70593 14.5878 8.85299 11.1466 13.4412 11.1466C18.0295 11.1466 19.1765 14.5878 19.1765 15.7348C19.1765 16.8819 18.0295 16.8819 18.0295 16.8819H8.85299ZM13.4412 9.99954C14.3539 9.99954 15.2292 9.63699 15.8745 8.99164C16.5199 8.3463 16.8824 7.47102 16.8824 6.55836C16.8824 5.64571 16.5199 4.77043 15.8745 4.12508C15.2292 3.47974 14.3539 3.11719 13.4412 3.11719C12.5286 3.11719 11.6533 3.47974 11.0079 4.12508C10.3626 4.77043 10.0001 5.64571 10.0001 6.55836C10.0001 7.47102 10.3626 8.3463 11.0079 8.99164C11.6533 9.63699 12.5286 9.99954 13.4412 9.99954Z",
    fill: "#9E3039"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.80667 16.8823C6.63662 16.5242 6.55182 16.1316 6.5589 15.7352C6.5589 14.1809 7.3389 12.5808 8.77961 11.4682C8.06051 11.2466 7.31131 11.1382 6.5589 11.147C1.97067 11.147 0.823608 14.5882 0.823608 15.7352C0.823608 16.8823 1.97067 16.8823 1.97067 16.8823H6.80667Z",
    fill: "#9E3039"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M5.98532 9.99994C6.74587 9.99994 7.47527 9.69782 8.01306 9.16003C8.55084 8.62224 8.85297 7.89284 8.85297 7.1323C8.85297 6.37175 8.55084 5.64235 8.01306 5.10456C7.47527 4.56677 6.74587 4.26465 5.98532 4.26465C5.22478 4.26465 4.49538 4.56677 3.95759 5.10456C3.4198 5.64235 3.11768 6.37175 3.11768 7.1323C3.11768 7.89284 3.4198 8.62224 3.95759 9.16003C4.49538 9.69782 5.22478 9.99994 5.98532 9.99994Z",
    fill: "#9E3039"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_50_5540"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.3529,
    height: 18.3529,
    fill: "white",
    transform: "translate(0.823608 0.823242)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployeeIconActive);
export default __webpack_public_path__ + "static/media/employee-icon-active.149893181addb884f530a7cd051af795.svg";
export { ForwardRef as ReactComponent };